import { beliveClient, beliveApiWraper } from './belive-client'
import { createMethod } from './tools'

export const api = {
  belive: createMethod(beliveClient, beliveApiWraper),
}
